export { default as Global } from './base'
